<template>
    <div class="personal-list-components">
        <div class="borad-operate-right">
            <div  @click="gotoList" class="personal-top flex justify-between items-center">
                <div>
                    <div class="personal-title">{{ $t('Board.Personal.title') }}</div>
                    <div class="personal-desc">
                        {{ $t('Board.Personal.sign') }} {{ none }} {{ $t('Board.Team.festival') }}
                         / {{ $t('Board.Personal.all') }} {{ total }} {{ $t('Board.Team.festival') }}</div>
                </div>
                <div class="iconfont icon-fitness-jiantouyou more"></div>
            </div>
            <!-- 无数据状态 -->
            <div v-if="!list.length" class="personal-content-none flex flex-column items-center">
                <div class="iconfont icon-fitness-meiyou-biaoqing none-data"></div>
                <div class="no-personal">{{ $t('Board.Personal.none') }}</div>
            </div>
            <!-- 有数据状态 -->
            <div class="personal-content-have">
                <div
                    class="personal-list flex items-center justify-between"
                    @click="gotoDetails(item)"
                    v-for="(item, index) in list"
                    :key="index">
                    <div class="flex items-center">
                        <p class="time">{{ item.lessonTime }}</p>
                        <div class="portrait relative">
                            <div
                                v-if="item.coachAvatar"
                                class="status-list-avatar"
                                :style="`background-image: url(${item.coachAvatar})`">
                            </div>
                            <img v-else src="../../../assets/images/saas-no-avatar.png" alt="100*100">
                        </div>
                        <div  class="personal-name">
                            <p class="name">{{ item.lessonName }}</p>
                            <p class="t">{{ item.placeName }}</p>
                            <p class="t">{{ item.coachNickname }}</p>
                        </div>
                    </div>
                    <div
                        :class="item.statusCode === 2 ? 'already' : ''"
                        class="personal-handle"
                    >
                        {{ item.statusCode === 2 ? $t('Board.Personal.signed') : $t('Board.Personal.sign') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'personal-list',
    components: {
    },
    data() {
        return {
            list: [],
            none: 0,
            total: 0,
            id: null,
        };
    },
    methods: {
        fetchData(id) {
            this.id = id;
            API.get('lesson/coach/schedule/dashboard', {
                params: {
                    storeId: id,
                },
            }).then(res => {
                this.none = res.unsignedAmt;
                this.total = res.totalAmt;
                this.list = res.schedules;
            });
        },
        gotoList() {
            if (!this.$$filterPermission('课程-私教预约表-仅查看上课教练是自己的')
                && !this.$$filterPermission('课程-私教预约表-查看全部私教预约记录')) {
                return this.$router.push('/403');
            }
            this.$router.push({
                name: 'Course',
                params: {
                    storeId: this.id,
                },
                query: {
                    activeName: 'third',
                },
            });
        },
        gotoDetails(item) {
            if (!this.$$filterPermission('课程-私教预约表-仅查看上课教练是自己的')
                && !this.$$filterPermission('课程-私教预约表-查看全部私教预约记录')) {
                return this.$router.push('/403');
            }
            this.$router.push({
                name: 'Course',
                query: {
                    storeId: this.id,
                    activeName: 'third',
                    coachId: item.coachId,
                    lessonEndAt: item.lessonEndAt,
                    lessonBeginAt: item.lessonBeginAt,
                },
            });
        },
    },
};
</script>

<style lang="scss">
.personal-list-components {
    width: 33%;
    height: 100%;
    height: 490px;
}
.borad-operate-right {
    margin-right: 1%;
    width: 100%;
    height: 100%;
    padding: 20px 25px;
    background: #fff;
    border-radius: 7px;

    &:last-child {
        margin-right: 0;
    }
}
.personal-title {
    font-size: 20px;
    color: #212121;
    font-weight: 400;
    margin-bottom: 4px;
}
.personal-desc {
    font-size: 14px;
    color: #8b8b8b;
}
.personal-content-none {
    margin-top: 120px;

    .iconfont.none-data {
        font-size: 50px;
        color: #d8d8d8;
    }
}
.no-personal {
    font-size: 15px;
    color: #999;
    margin-top: 20px;
}
.personal-top {
    cursor: pointer;
}
.personal-content-have {
    margin-top: 10px;
}
.personal-list {
    width: calc(100% + 20px);
    padding: 15px 10px;
    border-radius: 8px;
    position: relative;
    left: -10px;
    cursor: pointer;

    &:hover {
        box-shadow: 0 0 15px #77cef7;
        transition: box-shadow .5s;
    }

    .time {
        color: #8b8b8b;
        float: left;
        width: 50px;
        font-size: 13px;
    }
    .portrait {
        margin-right: 15px;
        img {
            width: 50px;
            height: 50px;
            border-radius: 100%;
        }
    }
    .personal-name {
        font-size: 12px;
        color: #8b8b8b;

        .name {
            font-size: 14px;
            color: #212121;
        }
    }
    .rank {
        width: 30px;
        margin-right: 30px;
        text-align: center;

        .iconfont {
            color: #f2bd03;
            font-size: 25px;
        }
    }
    &:nth-child(2) {
        .iconfont {
            color: #b7b7b7;
        }
    }
    &:nth-child(3) {
        .iconfont {
            color: #f19a5b;
        }
    }
    .txt {
        color: #949494;
        font-size: 14px;
    }
    &:nth-child(4),
    &:nth-child(5) {
        .txt {
            font-size: 24px;
            color: #949494;
            font-style: italic;
        }
    }
}
.personal-handle {
    background: #f87e7e;
    width: 56px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    font-size: 10px;
    color: #fff;
    border-radius: 12px;
}
.already {
    background: #c9c9c9;
}
</style>
